// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1fAL_","colCheckbox":"styles_colCheckbox__3VbBK"};